export default {
  SET_CUSTOMIZATION_CONFIGURATION: '@WS/CUSTOMIZATION/SET_CUSTOMIZATION_CONFIGURATION',
  SET_SITE_CUSTOMIZATION: '@WS/CUSTOMIZATION/SET_SITE_CUSTOMIZATION',
  SET_COLOR_PALETTE_CONFIG: '@WS/CUSTOMIZATION/SET_COLOR_PALETTE_CONFIG',
  ADD_CUSTOM_COLOR_PALETTE: '@WS/CUSTOMIZATION/ADD_CUSTOM_COLOR_PALETTE',
  DELETE_CUSTOM_COLOR_PALETTE: '@WS/CUSTOMIZATION/DELETE_CUSTOM_COLOR_PALETTE',
  UPDATE_CUSTOM_COLOR_PALETTE: '@WS/CUSTOMIZATION/UPDATE_CUSTOM_COLOR_PALETTE',
  SET_CURRENT_THEME: '@WS/CUSTOMIZATION/SET_CURRENT_THEME',
  SET_CURRENT_COLOR_PALETTE_VERSION: '@WS/CUSTOMIZATION/SET_CURRENT_COLOR_PALETTE_VERSION',
  SET_CURRENT_BUTTON_PRESET_VERSION: '@WS/CUSTOMIZATION/SET_CURRENT_BUTTON_PRESET_VERSION',
  ADD_CUSTOM_TEXT_COLOR: '@WS/CUSTOMIZATION/ADD_CUSTOM_TEXT_COLOR',
  ADD_CUSTOM_COLOR: '@WS/CUSTOMIZATION/ADD_CUSTOM_COLOR',
};
